import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { useReduxState } from "Shared/redux/useReduxState";
import { MyBookingSubwidget, MyBookingWidget } from "./KenticoKontent";

export const useMobileMyBooking = () => {
	const [kontent] = useReduxState("kontent.myBooking.myBookingTest.contents");

	const mobileItemTemplate = (widget: MyBookingWidget | MyBookingSubwidget) => html`
		<div class="flex items-center gap-2">
			<div class="flex h-7 w-7 items-center justify-center rounded-full bg-[F0F3F7] text-xs/none text-n-blue">
				${unsafeHTML(widget.icon.value)}
			</div>
			<div class="text-sm text-n-blue" @click=${() => (window.location.href = widget.url.value)}>
				${unsafeHTML(widget.title.value)}
			</div>
		</div>
	`;

	const htmlTemplate = () =>
		kontent
			? html`
					<div class="flex w-full flex-col items-start gap-2 px-1">
						${kontent.widget.map(mobileItemTemplate)} ${kontent.subwidget.map(mobileItemTemplate)}
					</div>
			  `
			: "";

	return { htmlTemplate };
};
